import React, { useState, useEffect } from "react";
import { Sidebar } from "react-pro-sidebar";
import "./LeftSide.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { DESKIE_API as API } from "../../config";
// sidebar image
import help from "../../Assets/Images/icon/lightbulb.svg";
import sidebarLogo from "../../Assets/Images/logo/logo.svg";
import { singleProfile } from "../../api/settings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

interface CollapseProps {
  collapsed: boolean;
  setCollapsed: (value: boolean) => void;
  plan: string
};

const LeftSide = ({ collapsed, setCollapsed, plan }: CollapseProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathArray = location.pathname.split("/");
  const urlParams = pathArray[pathArray.length - 1];
  const storeUserAuth = localStorage.getItem("company");
  const userAuth = JSON.parse(storeUserAuth as string);
  const [darkIconImage, setDarkIconImage] = useState("");

  const getSingleProfile = async () => {
    try {
      const { data } = await singleProfile();
      setDarkIconImage(data.company_logo_dark);
    } catch (err) {
      console.log(err);
    }
  };
  const onClick = () => {
    if (userAuth && userAuth.user.role === "admin") {
      navigate("/settings");
    }
    if (userAuth && userAuth.user.role !== "admin") {
      navigate("/my-settings");
    }
  };

  useEffect(() => {
    getSingleProfile();
  }, []);


  return (
    <div className='sideBar'>
      <Sidebar
        onBackdropClick={() => setCollapsed(false)}
        collapsed={collapsed}
        width='280px'
        collapsedWidth='0px'
      >
        <div className='sidebarBox'>
          <div>
            <div className="sidebarLogoContainer">
              <div className='sidebarLogo'>
                {darkIconImage ? (
                  <img src={`${API}/${darkIconImage}`} alt='admin' />
                ) : (
                  <div style={{ height: "33px" }}></div>
                )}
              </div>
              <div className="sidebar__menuClose" onClick={() => setCollapsed(true)}>
                <FontAwesomeIcon icon={faClose} />
              </div>
            </div>
            <div className='sidebarMenu' style={{ padding: "0px 15px" }}>
              {userAuth && userAuth.user.role === "admin" ? (
                <ul className='list-unstyled'>
                  <li
                    className={
                      urlParams === "dashboard"
                        ? "navLink activeMenu"
                        : "navLink"
                    }
                  >
                    <Link to='/dashboard'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M21 9L14.5515 13.6061C14.3555 13.746 14.2576 13.816 14.1527 13.8371C14.0602 13.8557 13.9643 13.8478 13.8762 13.8142C13.7762 13.7762 13.691 13.691 13.5208 13.5208L10.4792 10.4792C10.309 10.309 10.2238 10.2238 10.1238 10.1858C10.0357 10.1522 9.9398 10.1443 9.84732 10.1629C9.74241 10.184 9.64445 10.254 9.44853 10.3939L3 15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z'
                          stroke={
                            urlParams === "dashboard" ? "#FFFFFF" : "#98A2B3"
                          }
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      Dashboard
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "member" ? "navLink activeMenu" : "navLink"
                    }
                  >
                    <Link to='/member'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z'
                          stroke={
                            urlParams === "member" ? "#FFFFFF" : "#98A2B3"
                          }
                          strokeWidth='1.75'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      Members
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "assets" ? "navLink activeMenu" : "navLink"
                    }
                  >
                    <Link to='/assets'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M3 9H21M9 9L9 21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z'
                          stroke={
                            urlParams === "assets" ? "#FFFFFF" : "#98A2B3"
                          }
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      Assets
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "assignments"
                        ? "navLink activeMenu"
                        : "navLink"
                    }
                  >
                    <Link to='/assignments'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 18 21'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M15 8.5L13.59 7.08L7 13.67L4.41 11.09L3 12.5L7 16.5L15 8.5ZM16 2.5H11.82C11.4 1.34 10.3 0.5 9 0.5C7.7 0.5 6.6 1.34 6.18 2.5H2C1.86 2.5 1.73 2.51 1.6 2.54C1.21 2.62 0.86 2.82 0.59 3.09C0.41 3.27 0.26 3.49 0.16 3.73C0.0600001 3.96 0 4.22 0 4.5V18.5C0 18.77 0.0600001 19.04 0.16 19.28C0.26 19.52 0.41 19.73 0.59 19.92C0.86 20.19 1.21 20.39 1.6 20.47C1.73 20.49 1.86 20.5 2 20.5H16C17.1 20.5 18 19.6 18 18.5V4.5C18 3.4 17.1 2.5 16 2.5ZM9 2.25C9.41 2.25 9.75 2.59 9.75 3C9.75 3.41 9.41 3.75 9 3.75C8.59 3.75 8.25 3.41 8.25 3C8.25 2.59 8.59 2.25 9 2.25ZM16 18.5H2V4.5H16V18.5Z'
                          fill={
                            urlParams === "assignments" ? "#FFFFFF" : "#98A2B3"
                          }
                        />
                      </svg>
                      Assignments
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "resources"
                        ? "navLink activeMenu"
                        : "navLink"
                    }
                  >
                    <Link to='/resources'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <g clipPath='url(#clip0_10553_24214)'>
                          <path
                            d='M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM13 14H15V11H18V9H15V6H13V9H10V11H13V14Z'
                            fill={
                              urlParams === "resources" ? "#FFFFFF" : "#98A2B3"
                            }
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_10553_24214'>
                            <rect width='24' height='24' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                      Resources
                    </Link>
                  </li>
                  {/* <li
                    className={
                      urlParams === "bookings"
                        ? "navLink activeMenu"
                        : "navLink"
                    }
                  >
                    <Link to='/bookings'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z'
                          stroke='currentColor'
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      Bookings
                    </Link>
                  </li> */}
                  <li
                    className={
                      urlParams === "task" ? "navLink activeMenu" : "navLink"
                    }
                  >
                    <Link to='/task'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M1 10.9996L10.6422 15.8207C10.7734 15.8863 10.839 15.9191 10.9078 15.932C10.9687 15.9434 11.0313 15.9434 11.0922 15.932C11.161 15.9191 11.2266 15.8863 11.3578 15.8207L21 10.9996M1 15.9996L10.6422 20.8207C10.7734 20.8863 10.839 20.9191 10.9078 20.932C10.9687 20.9434 11.0313 20.9434 11.0922 20.932C11.161 20.9191 11.2266 20.8863 11.3578 20.8207L21 15.9996M1 5.99958L10.6422 1.17846C10.7734 1.11287 10.839 1.08008 10.9078 1.06717C10.9687 1.05574 11.0313 1.05574 11.0922 1.06717C11.161 1.08008 11.2266 1.11287 11.3578 1.17846L21 5.99958L11.3578 10.8207C11.2266 10.8863 11.161 10.9191 11.0922 10.932C11.0313 10.9434 10.9687 10.9434 10.9078 10.932C10.839 10.9191 10.7734 10.8863 10.6422 10.8207L1 5.99958Z'
                          stroke={urlParams === "task" ? "#FFFFFF" : "#98A2B3"}
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      Tasks
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "messenger"
                        ? "navLink activeMenu"
                        : "navLink"
                    }
                  >
                    <Link to='/messenger'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M7.5 12H7.51M12 12H12.01M16.5 12H16.51M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21ZM8 12C8 12.2761 7.77614 12.5 7.5 12.5C7.22386 12.5 7 12.2761 7 12C7 11.7239 7.22386 11.5 7.5 11.5C7.77614 11.5 8 11.7239 8 12ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12ZM17 12C17 12.2761 16.7761 12.5 16.5 12.5C16.2239 12.5 16 12.2761 16 12C16 11.7239 16.2239 11.5 16.5 11.5C16.7761 11.5 17 11.7239 17 12Z'
                          stroke={
                            urlParams === "messenger" ? "#FFFFFF" : "#98A2B3"
                          }
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      Messages
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "feed" ? "navLink activeMenu" : "navLink"
                    }
                  >
                    <Link to='/feed'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <g clipPath='url(#clip0_9672_27170)'>
                          <path
                            d='M6.18 20.0006C7.38398 20.0006 8.36 19.0246 8.36 17.8206C8.36 16.6166 7.38398 15.6406 6.18 15.6406C4.97602 15.6406 4 16.6166 4 17.8206C4 19.0246 4.97602 20.0006 6.18 20.0006Z'
                            fill={urlParams === "feed" ? "#FFFFFF" : "#98A2B3"}
                          />
                          <path
                            d='M4 4.4375V7.2675C11.03 7.2675 16.73 12.9675 16.73 19.9975H19.56C19.56 11.4075 12.59 4.4375 4 4.4375ZM4 10.0975V12.9275C7.9 12.9275 11.07 16.0975 11.07 19.9975H13.9C13.9 14.5275 9.47 10.0975 4 10.0975Z'
                            fill={urlParams === "feed" ? "#FFFFFF" : "#98A2B3"}
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_9672_27170'>
                            <rect width='24' height='24' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                      Feed
                    </Link>
                  </li>
                  <li className={urlParams === "tickets" ? "navLink activeMenu" : "navLink"}>
                    <Link to="/tickets"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 8V7M8 12.5V11.5M8 17V16M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z" stroke={urlParams === "tickets" ? "#FFFFFF" : "#98A2B3"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>Ticket</Link>
                  </li>
                  <li
                    className={
                      urlParams === "calender"
                        ? "navLink activeMenu"
                        : "navLink"
                    }
                  >
                    <Link to='/calender'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z'
                          stroke={
                            urlParams === "calender" ? "#FFFFFF" : "#98A2B3"
                          }
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      Calendar
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "files" ? "navLink activeMenu" : "navLink"
                    }
                  >
                    <Link to='/files'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7Z'
                          stroke={urlParams === "files" ? "#FFFFFF" : "#98A2B3"}
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      Files
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "billing" ? "navLink activeMenu" : "navLink"
                    }
                  >
                    <Link to='/billing'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M16 8.00007V4.50073C16 3.66899 16 3.25312 15.8248 2.99755C15.6717 2.77425 15.4346 2.62257 15.1678 2.57715C14.8623 2.52517 14.4847 2.69944 13.7295 3.04799L4.85901 7.14206C4.18551 7.45291 3.84875 7.60834 3.60211 7.84939C3.38406 8.06249 3.21762 8.32262 3.1155 8.6099C3 8.93486 3 9.30575 3 10.0475V15.0001M16.5 14.5001H16.51M3 11.2001L3 17.8001C3 18.9202 3 19.4802 3.21799 19.9081C3.40973 20.2844 3.71569 20.5903 4.09202 20.7821C4.51984 21.0001 5.07989 21.0001 6.2 21.0001H17.8C18.9201 21.0001 19.4802 21.0001 19.908 20.7821C20.2843 20.5903 20.5903 20.2844 20.782 19.9081C21 19.4802 21 18.9202 21 17.8001V11.2001C21 10.08 21 9.51992 20.782 9.09209C20.5903 8.71577 20.2843 8.40981 19.908 8.21806C19.4802 8.00007 18.9201 8.00007 17.8 8.00007L6.2 8.00007C5.0799 8.00007 4.51984 8.00007 4.09202 8.21806C3.7157 8.40981 3.40973 8.71577 3.21799 9.09209C3 9.51991 3 10.08 3 11.2001ZM17 14.5001C17 14.7762 16.7761 15.0001 16.5 15.0001C16.2239 15.0001 16 14.7762 16 14.5001C16 14.2239 16.2239 14.0001 16.5 14.0001C16.7761 14.0001 17 14.2239 17 14.5001Z'
                          stroke={
                            urlParams === "billing" ? "#FFFFFF" : "#98A2B3"
                          }
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      Finances
                    </Link>
                    {/* <button className={urlParams === "billing" ? "btn btn-toggle align-items-center rounded collapsed" : "btn btn-toggle align-items-center rounded collapsed"} data-bs-toggle="collapse" data-bs-target="#home-collapse" aria-expanded="false">
                                        <img src={wallet02} alt="dashboard" />Finances
                                    </button>
                                    <div className={urlParams === "billing" ? "collapse show" : "collapse"} id="home-collapse">
                                        <ul className="btn-toggle-nav list-unstyled fw-normal small">
                                            <li className={urlParams === "billing" ? "activeDropdownMenu" : ""}><Link to="/billing">Billing</Link></li>
                                        </ul>
                                    </div> */}
                  </li>
                  <li
                    className={
                      urlParams === "visitor-log"
                        ? "navLink activeMenu"
                        : "navLink"
                    }
                  >
                    <Link to='/visitor-log'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M16 18L18 20L22 16M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z'
                          stroke={
                            urlParams === "visitor-log" ? "#FFFFFF" : "#98A2B3"
                          }
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      Visitor Log
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "tours" ? "navLink activeMenu" : "navLink"
                    }
                  >
                    <Link to='/tours'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 20 22'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M14.49 14V12.25L12 14.75L14.49 17.25V15.5H20V14H14.49ZM17.51 18.25H12V19.75H17.51V21.5L20 19L17.51 16.5V18.25ZM7.5 4C8.6 4 9.5 3.1 9.5 2C9.5 0.9 8.6 0 7.5 0C6.4 0 5.5 0.9 5.5 2C5.5 3.1 6.4 4 7.5 4ZM3.75 7.4L1 21.5H3.1L4.85 13.5L7 15.5V21.5H9V13.95L6.95 11.9L7.55 8.9C8.85 10.5 10.8 11.5 13 11.5V9.5C11.15 9.5 9.55 8.5 8.65 7.05L7.7 5.45C7.35 4.85 6.7 4.5 6 4.5C5.75 4.5 5.5 4.55 5.25 4.65L0 6.8V11.5H2V8.15L3.75 7.4Z'
                          fill={urlParams === "tours" ? "#FFFFFF" : "#98A2B3"}
                        />
                      </svg>
                      Tours
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "mail" ? "navLink activeMenu" : "navLink"
                    }
                  >
                    <Link to='/mail'>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 7.53125L10.1649 13.2467C10.8261 13.7095 11.1567 13.9409 11.5163 14.0306C11.8339 14.1097 12.1661 14.1097 12.4837 14.0306C12.8433 13.9409 13.1739 13.7095 13.8351 13.2467L22 7.53125M6.8 20.5312H17.2C18.8802 20.5312 19.7202 20.5312 20.362 20.2043C20.9265 19.9166 21.3854 19.4577 21.673 18.8932C22 18.2515 22 17.4114 22 15.7312V9.33125C22 7.65109 22 6.81101 21.673 6.16928C21.3854 5.60479 20.9265 5.14585 20.362 4.85823C19.7202 4.53125 18.8802 4.53125 17.2 4.53125H6.8C5.11984 4.53125 4.27976 4.53125 3.63803 4.85823C3.07354 5.14585 2.6146 5.60479 2.32698 6.16928C2 6.81101 2 7.65109 2 9.33125V15.7312C2 17.4114 2 18.2515 2.32698 18.8932C2.6146 19.4577 3.07354 19.9166 3.63803 20.2043C4.27976 20.5312 5.11984 20.5312 6.8 20.5312Z" stroke={
                          urlParams === "mail" ? "#FFFFFF" : "#98A2B3"
                        } strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      Mail
                    </Link>
                  </li>
                  {plan === "enterprise" && (
                    <li
                      className={
                        urlParams === "website" ? "navLink activeMenu" : "navLink"
                      }
                    >
                      <Link to='/website'>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_16639_39197)">
                            <path d="M20 18C21.1 18 22 17.1 22 16V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V16C2 17.1 2.9 18 4 18H0V20H24V18H20ZM4 6H20V16H4V6Z" fill={urlParams === "website" ? "#FFFFFF" : "#98A2B3"} />
                          </g>
                          <defs>
                            <clipPath id="clip0_16639_39197">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        WebSite
                      </Link>
                    </li>
                  )}
                </ul>
              ) : (
                <ul className='list-unstyled'>
                  <li
                    className={
                      urlParams === "my-home" ? "navLink activeMenu" : "navLink"
                    }
                  >
                    <Link to='/my-home'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M21 9L14.5515 13.6061C14.3555 13.746 14.2576 13.816 14.1527 13.8371C14.0602 13.8557 13.9643 13.8478 13.8762 13.8142C13.7762 13.7762 13.691 13.691 13.5208 13.5208L10.4792 10.4792C10.309 10.309 10.2238 10.2238 10.1238 10.1858C10.0357 10.1522 9.9398 10.1443 9.84732 10.1629C9.74241 10.184 9.64445 10.254 9.44853 10.3939L3 15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z'
                          stroke={
                            urlParams === "my-home" ? "#FFFFFF" : "#98A2B3"
                          }
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      Home
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "my-resources"
                        ? "navLink activeMenu"
                        : "navLink"
                    }
                  >
                    <Link to='/my-resources'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <g clipPath='url(#clip0_10553_24214)'>
                          <path
                            d='M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM13 14H15V11H18V9H15V6H13V9H10V11H13V14Z'
                            fill={
                              urlParams === "my-resources"
                                ? "#FFFFFF"
                                : "#98A2B3"
                            }
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_10553_24214'>
                            <rect width='24' height='24' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                      Resources
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "my-feed" ? "navLink activeMenu" : "navLink"
                    }
                  >
                    <Link to='/my-feed'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <g clipPath='url(#clip0_9672_27170)'>
                          <path
                            d='M6.18 20.0006C7.38398 20.0006 8.36 19.0246 8.36 17.8206C8.36 16.6166 7.38398 15.6406 6.18 15.6406C4.97602 15.6406 4 16.6166 4 17.8206C4 19.0246 4.97602 20.0006 6.18 20.0006Z'
                            fill={urlParams === "my-feed" ? "#FFFFFF" : "#98A2B3"}
                          />
                          <path
                            d='M4 4.4375V7.2675C11.03 7.2675 16.73 12.9675 16.73 19.9975H19.56C19.56 11.4075 12.59 4.4375 4 4.4375ZM4 10.0975V12.9275C7.9 12.9275 11.07 16.0975 11.07 19.9975H13.9C13.9 14.5275 9.47 10.0975 4 10.0975Z'
                            fill={urlParams === "my-feed" ? "#FFFFFF" : "#98A2B3"}
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_9672_27170'>
                            <rect width='24' height='24' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                      Feed
                    </Link>
                  </li>
                  <li className={urlParams === "my-tickets" ? "navLink activeMenu" : "navLink"}>
                    <Link to="/my-tickets"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 8V7M8 12.5V11.5M8 17V16M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z" stroke={urlParams === "my-tickets" ? "#FFFFFF" : "#98A2B3"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>Ticket</Link>
                  </li>
                  <li
                    className={
                      urlParams === "my-messenger"
                        ? "navLink activeMenu"
                        : "navLink"
                    }
                  >
                    <Link to='/my-messenger'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M7.5 12H7.51M12 12H12.01M16.5 12H16.51M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21ZM8 12C8 12.2761 7.77614 12.5 7.5 12.5C7.22386 12.5 7 12.2761 7 12C7 11.7239 7.22386 11.5 7.5 11.5C7.77614 11.5 8 11.7239 8 12ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12ZM17 12C17 12.2761 16.7761 12.5 16.5 12.5C16.2239 12.5 16 12.2761 16 12C16 11.7239 16.2239 11.5 16.5 11.5C16.7761 11.5 17 11.7239 17 12Z'
                          stroke={
                            urlParams === "my-messenger" ? "#FFFFFF" : "#98A2B3"
                          }
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      My Message
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "my-files"
                        ? "navLink activeMenu"
                        : "navLink"
                    }
                  >
                    <Link to='/my-files'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7Z'
                          stroke={
                            urlParams === "my-files" ? "#FFFFFF" : "#98A2B3"
                          }
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      My Files
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "my-invoice"
                        ? "navLink activeMenu"
                        : "navLink"
                    }
                  >
                    <Link to='/my-invoice'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M16 8.00007V4.50073C16 3.66899 16 3.25312 15.8248 2.99755C15.6717 2.77425 15.4346 2.62257 15.1678 2.57715C14.8623 2.52517 14.4847 2.69944 13.7295 3.04799L4.85901 7.14206C4.18551 7.45291 3.84875 7.60834 3.60211 7.84939C3.38406 8.06249 3.21762 8.32262 3.1155 8.6099C3 8.93486 3 9.30575 3 10.0475V15.0001M16.5 14.5001H16.51M3 11.2001L3 17.8001C3 18.9202 3 19.4802 3.21799 19.9081C3.40973 20.2844 3.71569 20.5903 4.09202 20.7821C4.51984 21.0001 5.07989 21.0001 6.2 21.0001H17.8C18.9201 21.0001 19.4802 21.0001 19.908 20.7821C20.2843 20.5903 20.5903 20.2844 20.782 19.9081C21 19.4802 21 18.9202 21 17.8001V11.2001C21 10.08 21 9.51992 20.782 9.09209C20.5903 8.71577 20.2843 8.40981 19.908 8.21806C19.4802 8.00007 18.9201 8.00007 17.8 8.00007L6.2 8.00007C5.0799 8.00007 4.51984 8.00007 4.09202 8.21806C3.7157 8.40981 3.40973 8.71577 3.21799 9.09209C3 9.51991 3 10.08 3 11.2001ZM17 14.5001C17 14.7762 16.7761 15.0001 16.5 15.0001C16.2239 15.0001 16 14.7762 16 14.5001C16 14.2239 16.2239 14.0001 16.5 14.0001C16.7761 14.0001 17 14.2239 17 14.5001Z'
                          stroke={
                            urlParams === "my-invoice" ? "#FFFFFF" : "#98A2B3"
                          }
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      My Billing
                    </Link>
                  </li>
                  <li
                    className={
                      urlParams === "my-mail"
                        ? "navLink activeMenu"
                        : "navLink"
                    }
                  >
                    <Link to='/my-mail'>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 7.53125L10.1649 13.2467C10.8261 13.7095 11.1567 13.9409 11.5163 14.0306C11.8339 14.1097 12.1661 14.1097 12.4837 14.0306C12.8433 13.9409 13.1739 13.7095 13.8351 13.2467L22 7.53125M6.8 20.5312H17.2C18.8802 20.5312 19.7202 20.5312 20.362 20.2043C20.9265 19.9166 21.3854 19.4577 21.673 18.8932C22 18.2515 22 17.4114 22 15.7312V9.33125C22 7.65109 22 6.81101 21.673 6.16928C21.3854 5.60479 20.9265 5.14585 20.362 4.85823C19.7202 4.53125 18.8802 4.53125 17.2 4.53125H6.8C5.11984 4.53125 4.27976 4.53125 3.63803 4.85823C3.07354 5.14585 2.6146 5.60479 2.32698 6.16928C2 6.81101 2 7.65109 2 9.33125V15.7312C2 17.4114 2 18.2515 2.32698 18.8932C2.6146 19.4577 3.07354 19.9166 3.63803 20.2043C4.27976 20.5312 5.11984 20.5312 6.8 20.5312Z" stroke={
                          urlParams === "my-mail" ? "#FFFFFF" : "#98A2B3"
                        } strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      Mail
                    </Link>
                  </li>
                </ul>
              )}
            </div>
          </div>
          <div className='sidebarFooter'>
            <ul>
              <li className='dropNavLink'>
                <button
                  className={
                    urlParams === "settings" || urlParams === "my-settings"
                      ? "navLink activeMenu btn btn-toggle"
                      : "navLink btn btn-toggle"
                  }
                  onClick={onClick}
                >
                  <svg
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z'
                      stroke={
                        urlParams === "settings" || urlParams === "my-settings"
                          ? "#FFFFFF"
                          : "#98A2B3"
                      }
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z'
                      stroke={
                        urlParams === "settings" || urlParams === "my-settings"
                          ? "#FFFFFF"
                          : "#98A2B3"
                      }
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                  Settings
                </button>
                {/* <div className="collapse" id="help-collapse" >
                                    <ul className="btn-toggle-nav list-unstyled fw-normal small">
                                        <li><Link to="#"><img src={dashboard} alt="dashboard" /> Sub-menu</Link></li>
                                        <li><Link to="#"><img src={dashboard} alt="dashboard" /> Sub-menu</Link></li>
                                    </ul>
                                </div> */}
              </li>
            </ul>
          </div>
        </div>
      </Sidebar>
    </div>
  );
};

export default LeftSide;
